import React, { useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircleInfo } from '@fortawesome/free-solid-svg-icons';
import './../../scss/controls/_infoIcon.scss';
import { GenericPopup } from './GenericPopup';
import { ButtonTheme } from './Button';

interface InfoIconButtonProps {
    active?: boolean;
    /** The popup's content: plain text or any element (e.g. formatted text in a div). */
    modalText?: React.ReactNode;
}

export const InfoIconButton: React.FC<InfoIconButtonProps> = ({ active = false, modalText }) => {
    const [showModal, setShowModal] = useState(false);

    const handleClick = () => {
        setShowModal(true);
    };

    const closeModal = () => {
        setShowModal(false);
    };

    const actionButtons = [
        {
            id: 'okButton',
            theme: ButtonTheme.Primary,
            disabled: false,
            children: 'Close',
            width: '200px',
            handleClick: closeModal,
        },
    ];

    return (
        <>
            <span
                className={`infoIcon ${active ? 'active' : ''}`}
                onClick={handleClick}
            >
                <FontAwesomeIcon icon={faCircleInfo} />
            </span>

            {showModal && (
                <GenericPopup
                    id='fieldInformationPopup'
                    isOpen={showModal}
                    actionButtons={actionButtons}
                    title='Information'
                    showTitle={true}
                    showCloseButton={true}
                    width='400px'
                    maxWidth='96%'
                    maxHeight='400px'
                    handleClose={closeModal}
                >
                    <div className='infoIconText'>{modalText}</div>
                </GenericPopup>
            )}
        </>
    );
};
